import React from "react";
import { Link } from "react-router-dom";

// assets
import ProfilePic from "src/assets/images/profile/avatar-1.png";
import MoonIcon from "src/assets/images/profile/moon.svg";
import ArrowLeftIcon from "src/assets/images/profile/arrow-left-white.svg";

import styles from "./styles.module.scss";

const ProfileHeader = () => {
  return (
    <>
      <div className={styles.bg__gradient}>
        <div></div>
      </div>
      <div className={styles.header__wrapper}>
        <span className={styles.contact__mob}>Contact</span>
        <Link to="/" className={styles.back}>
          <img src={ArrowLeftIcon} alt="back" />
        </Link>
        <div className={styles.avatar}>
          <div className={styles.img__wrapper}>
            <img src={ProfilePic} alt="profile" />
          </div>
          <h3>Ahtesham</h3>
          <span className={styles.tag__mob}>Trusted Promoter</span>
          <p className={styles.bio__mob}>
            What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing
            and typesetting industry
          </p>
          <button>Follow</button>
        </div>
        <div className={styles.info}>
          <div>
            <span className={styles.numb}>201</span>
            <span className={styles.label}>Total Events</span>
          </div>
          <span className={styles.divider}></span>
          <div>
            <span className={styles.numb}>2</span>
            <span className={styles.label}>Upcoming Events</span>
          </div>
          <span className={styles.divider}></span>
          <div>
            <span className={`${styles.numb} ${styles.icon__wrapper}`}>
              <img src={MoonIcon} alt="moon" /> 120
            </span>
            <span className={styles.label}>Followers</span>
          </div>
          <span className={styles.tag}>Trusted Promoter</span>
        </div>
      </div>
      <p className={styles.bio}>
        What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and
        typesetting industry Lorem Ipsum has been the industry's standard dummy
        text ever since the 1500s when an unknown printer took a galley of type
        and scrambled it to make a type specimen book it has?
      </p>
    </>
  );
};

export default ProfileHeader;
